<div class="fibu-check">
    <header class="fc-header">
        <div>
            <h1>FiBu-Check (Nebenkosten)</h1>
            <p class="fc-sub">
                Auswertung: Stammdaten, Volumen, Lieferanten, Positionsqualität, Abweichungen.
                <span *ngIf="data">Mandant {{ data.mandant_id }} · {{ data.generated_at | date: 'dd.MM.yyyy HH:mm' }}</span>
            </p>
        </div>
        <div class="fc-header-actions">
            <button
                mat-flat-button
                type="button"
                color="accent"
                (click)="toggleProblemsJson()"
                [disabled]="loading || !data"
            >
                <mat-icon>content_copy</mat-icon>
                Probleme als JSON
            </button>
            <button mat-stroked-button type="button" color="primary" (click)="reload()" [disabled]="loading">
                <mat-icon>refresh</mat-icon>
                Neu laden
            </button>
        </div>
    </header>

    <section class="fc-json-panel" *ngIf="showProblemsJson && problemsJson">
        <div class="fc-json-bar">
            <strong>Probleme (JSON)</strong>
            <span class="fc-hint-inline">Markieren + Strg+C oder Button „Kopieren“</span>
            <button mat-flat-button type="button" color="primary" (click)="copyProblemsJson()">
                <mat-icon>content_copy</mat-icon>
                Kopieren
            </button>
            <button mat-stroked-button type="button" (click)="selectProblemsJson()">Alles markieren</button>
            <button mat-icon-button type="button" (click)="showProblemsJson = false" aria-label="Schließen">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <textarea
            #problemsJsonArea
            class="fc-json-area"
            readonly
            [value]="problemsJson"
            (focus)="selectProblemsJson()"
            (click)="selectProblemsJson()"
        ></textarea>
    </section>

    <div class="fc-loading" *ngIf="loading">Lade Auswertung…</div>

    <ng-container *ngIf="!loading && data">
        <section class="fc-summary">
            <div
                class="fc-card score"
                [class.good]="healthScore >= 80"
                [class.mid]="healthScore >= 50 && healthScore < 80"
                [class.bad]="healthScore < 50"
            >
                <span class="fc-num">{{ healthScore }}%</span>
                <span class="fc-label">Stammdaten OK</span>
            </div>
            <div
                class="fc-card score"
                [class.good]="riskScore < 15"
                [class.mid]="riskScore >= 15 && riskScore < 40"
                [class.bad]="riskScore >= 40"
            >
                <span class="fc-num">{{ riskScore }}</span>
                <span class="fc-label">Risiko-Index</span>
            </div>
            <div class="fc-card" (click)="setFilter('all')" role="button">
                <span class="fc-num">{{ data.summary.artikel_gesamt }}</span>
                <span class="fc-label">Artikel</span>
            </div>
            <div class="fc-card ok" (click)="setFilter('ok')" role="button">
                <span class="fc-num">{{ data.summary.ok }}</span>
                <span class="fc-label">OK</span>
            </div>
            <div class="fc-card warn" (click)="setFilter('critical')" role="button">
                <span class="fc-num">{{ data.summary.kritisch_genutzt || 0 }}</span>
                <span class="fc-label">kritisch genutzt</span>
            </div>
            <div class="fc-card warn" (click)="tab = 'abweichungen'" role="button">
                <span class="fc-num">{{ data.konto_mismatches?.length || 0 }}</span>
                <span class="fc-label">Abweichungen</span>
            </div>
            <div class="fc-card" (click)="tab = 'volumen'" role="button">
                <span class="fc-num">{{ euro(data.summary.netto_90d) }}</span>
                <span class="fc-label">Netto 90d €</span>
            </div>
            <div class="fc-card" (click)="setFilter('aktiv')" role="button">
                <span class="fc-num">{{ data.summary.mit_positionen_90d }}</span>
                <span class="fc-label">aktiv (90d)</span>
            </div>
            <div class="fc-card" (click)="tab = 'lieferanten'" role="button">
                <span class="fc-num">{{ data.lieferanten?.length || 0 }}</span>
                <span class="fc-label">Lieferanten aktiv</span>
            </div>
            <div class="fc-card" (click)="tab = 'qualitaet'" role="button">
                <span class="fc-num">{{ data.position_quality?.offen_90d || 0 }}</span>
                <span class="fc-label">Belege offen</span>
            </div>
        </section>

        <nav class="fc-tabs">
            <button type="button" mat-button [class.active]="tab === 'analyse'" (click)="tab = 'analyse'">Analyse</button>
            <button type="button" mat-button [class.active]="tab === 'volumen'" (click)="tab = 'volumen'">Volumen</button>
            <button type="button" mat-button [class.active]="tab === 'artikel'" (click)="tab = 'artikel'">Artikel</button>
            <button type="button" mat-button [class.active]="tab === 'lieferanten'" (click)="tab = 'lieferanten'">
                Lieferanten
            </button>
            <button type="button" mat-button [class.active]="tab === 'abweichungen'" (click)="tab = 'abweichungen'">
                Abweichungen ({{ mismatchGroups.length }})
            </button>
            <button type="button" mat-button [class.active]="tab === 'konten'" (click)="tab = 'konten'">
                Nach Konto ({{ kontoGroups.length }})
            </button>
            <button type="button" mat-button [class.active]="tab === 'qualitaet'" (click)="tab = 'qualitaet'">Qualität</button>
        </nav>

        <!-- ANALYSE -->
        <section *ngIf="tab === 'analyse'" class="fc-analyse">
            <div class="fc-grid-2">
                <div>
                    <h2>Was zuerst anfassen?</h2>
                    <p class="fc-hint">Priorisierte Maßnahmen – Klick öffnet die passende Ansicht.</p>
                    <div class="fc-actions" *ngIf="actions.length; else allGood">
                        <button
                            type="button"
                            class="fc-action"
                            *ngFor="let a of actions"
                            [class]="severityClass(a.severity)"
                            (click)="openAction(a)"
                        >
                            <span class="sev-tag">{{ a.severity }}</span>
                            <div class="fc-action-body">
                                <strong>{{ a.title }}</strong>
                                <span>{{ a.detail }}</span>
                            </div>
                            <span class="fc-action-count">{{ a.count }}</span>
                        </button>
                    </div>
                    <ng-template #allGood>
                        <p class="fc-good">Keine kritischen Lücken – Stammdaten sehen gut aus.</p>
                    </ng-template>
                </div>
                <div>
                    <h2>Problemverteilung</h2>
                    <google-chart
                        style="width: 100%; height: 280px"
                        [type]="chartTypePie"
                        [columns]="issuePieColumns"
                        [data]="issuePieData"
                    ></google-chart>
                </div>
            </div>

            <div class="fc-grid-2 mt">
                <div>
                    <h2>Netto-Trend (12 Monate)</h2>
                    <google-chart
                        style="width: 100%; height: 260px"
                        [type]="chartTypeLine"
                        [columns]="monthlyColumns"
                        [data]="monthlyData"
                    ></google-chart>
                </div>
                <div>
                    <h2>Top-Konten nach Netto (90d)</h2>
                    <google-chart
                        style="width: 100%; height: 260px"
                        [type]="chartTypePie"
                        [columns]="kontoPieColumns"
                        [data]="kontoPieData"
                    ></google-chart>
                </div>
            </div>

            <h2 class="mt">Konto-Abdeckung (Top nach Netto 90d)</h2>
            <table class="fc-table">
                <thead>
                    <tr>
                        <th>Sachkonto</th>
                        <th>Artikel</th>
                        <th>OK</th>
                        <th>Probleme</th>
                        <th>Pos. 90d</th>
                        <th>Netto 90d</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let g of kontoGroups | slice: 0:15" (click)="openKontoGroup(g.baseKonto)" class="clickable">
                        <td class="mono">{{ g.baseKonto }}</td>
                        <td>{{ g.artikelCount }}</td>
                        <td>{{ g.okCount }}</td>
                        <td [class.warn-text]="g.issueCount > 0">{{ g.issueCount }}</td>
                        <td>{{ g.positionen90d }}</td>
                        <td class="num">{{ euro(g.netto90d) }}</td>
                    </tr>
                </tbody>
            </table>

            <h2 class="mt">Warengruppen</h2>
            <table class="fc-table">
                <thead>
                    <tr>
                        <th>Warengruppe</th>
                        <th>Artikel</th>
                        <th>OK</th>
                        <th>Probleme</th>
                        <th>Pos. 90d</th>
                        <th>Netto 90d</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let w of data.warengruppen">
                        <td>{{ w.warengruppe }}</td>
                        <td>{{ w.artikel_count }}</td>
                        <td>{{ w.ok }}</td>
                        <td [class.warn-text]="w.issues > 0">{{ w.issues }}</td>
                        <td>{{ w.positionen_90d }}</td>
                        <td class="num">{{ euro(w.netto_90d) }}</td>
                    </tr>
                </tbody>
            </table>
        </section>

        <!-- VOLUMEN -->
        <section *ngIf="tab === 'volumen'" class="fc-analyse">
            <div class="fc-kpi-row">
                <div class="fc-card">
                    <span class="fc-num">{{ euro(data.summary.netto_90d) }}</span>
                    <span class="fc-label">Netto 90 Tage</span>
                </div>
                <div class="fc-card">
                    <span class="fc-num">{{ euro(data.summary.netto_365d) }}</span>
                    <span class="fc-label">Netto 365 Tage</span>
                </div>
                <div class="fc-card">
                    <span class="fc-num">{{ data.position_quality?.belege_90d || 0 }}</span>
                    <span class="fc-label">Belege 90d</span>
                </div>
                <div class="fc-card">
                    <span class="fc-num">{{ data.position_quality?.positionen_90d || 0 }}</span>
                    <span class="fc-label">Positionen 90d</span>
                </div>
                <div class="fc-card">
                    <span class="fc-num">{{ euro(data.position_quality?.soll_netto_90d) }}</span>
                    <span class="fc-label">Soll-Netto 90d</span>
                </div>
                <div class="fc-card">
                    <span class="fc-num">{{ euro(data.position_quality?.haben_netto_90d) }}</span>
                    <span class="fc-label">Haben-Netto 90d</span>
                </div>
            </div>

            <div class="fc-grid-2">
                <div>
                    <h2>Monatlicher Verlauf</h2>
                    <google-chart
                        style="width: 100%; height: 300px"
                        [type]="chartTypeLine"
                        [columns]="monthlyColumns"
                        [data]="monthlyData"
                    ></google-chart>
                    <table class="fc-table">
                        <thead>
                            <tr>
                                <th>Monat</th>
                                <th>Belege</th>
                                <th>Positionen</th>
                                <th>Netto</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let m of data.monthly_trend">
                                <td class="mono">{{ m.monatz }}</td>
                                <td>{{ m.belege }}</td>
                                <td>{{ m.positionen }}</td>
                                <td class="num">{{ euro(m.netto) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <h2>Top Lieferanten (90d)</h2>
                    <google-chart
                        style="width: 100%; height: 300px"
                        [type]="chartTypePie"
                        [columns]="liefPieColumns"
                        [data]="liefPieData"
                    ></google-chart>
                </div>
            </div>

            <div class="fc-grid-2 mt">
                <div>
                    <h2>Top Konten (90d)</h2>
                    <table class="fc-table">
                        <thead>
                            <tr>
                                <th>Konto</th>
                                <th>Basis</th>
                                <th>Belege</th>
                                <th>Pos.</th>
                                <th>Netto</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let k of data.usage_by_konto">
                                <td class="mono">{{ k.konto_nr }}</td>
                                <td class="mono">{{ k.base_konto }}</td>
                                <td>{{ k.belege }}</td>
                                <td>{{ k.positionen }}</td>
                                <td class="num">{{ euro(k.netto) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <h2>Top Artikel (90d)</h2>
                    <table class="fc-table">
                        <thead>
                            <tr>
                                <th>Artikel</th>
                                <th>Konto</th>
                                <th>Belege</th>
                                <th>Pos.</th>
                                <th>Netto</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let a of data.usage_by_artikel">
                                <td>{{ a.artikel }}</td>
                                <td class="mono">{{ a.buchungskonto || '—' }}</td>
                                <td>{{ a.belege }}</td>
                                <td>{{ a.positionen }}</td>
                                <td class="num">{{ euro(a.netto) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <h2 class="mt">Top Lieferanten Detail (90d)</h2>
            <table class="fc-table">
                <thead>
                    <tr>
                        <th>Lieferant</th>
                        <th>Kreditor</th>
                        <th>Gegenkonto (Stamm)</th>
                        <th>Belege</th>
                        <th>Pos.</th>
                        <th>Netto</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let l of data.usage_by_lieferant">
                        <td>{{ l.lieferant }}</td>
                        <td class="mono">{{ l.kreditor_nr || '—' }}</td>
                        <td class="mono">{{ l.buchungsgegenkonto || '—' }}</td>
                        <td>{{ l.belege }}</td>
                        <td>{{ l.positionen }}</td>
                        <td class="num">{{ euro(l.netto) }}</td>
                    </tr>
                </tbody>
            </table>
        </section>

        <!-- ARTIKEL -->
        <section *ngIf="tab === 'artikel'">
            <div class="fc-filters">
                <button mat-button type="button" [class.active]="filter === 'all'" (click)="filter = 'all'">Alle</button>
                <button mat-button type="button" [class.active]="filter === 'critical'" (click)="filter = 'critical'">
                    Kritisch
                </button>
                <button mat-button type="button" [class.active]="filter === 'aktiv'" (click)="filter = 'aktiv'">Aktiv 90d</button>
                <button mat-button type="button" [class.active]="filter === 'issues'" (click)="filter = 'issues'">
                    Probleme
                </button>
                <button mat-button type="button" [class.active]="filter === 'ok'" (click)="filter = 'ok'">OK</button>
                <button
                    mat-button
                    type="button"
                    [class.active]="filter === 'konto_nicht_im_rahmen'"
                    (click)="filter = 'konto_nicht_im_rahmen'"
                >
                    Konto fehlt
                </button>
                <button mat-button type="button" [class.active]="filter === 'ohne_tags'" (click)="filter = 'ohne_tags'">
                    Ohne Tags
                </button>
                <mat-form-field class="fc-search" appearance="outline">
                    <mat-label>Suche</mat-label>
                    <input matInput [formControl]="searchCtrl" placeholder="Name, Kürzel, Konto, Tag…" />
                </mat-form-field>
                <mat-form-field class="fc-sort" appearance="outline">
                    <mat-label>Sortierung</mat-label>
                    <mat-select [(value)]="sortBy">
                        <mat-option value="severity">Priorität</mat-option>
                        <mat-option value="netto">Netto 90d</mat-option>
                        <mat-option value="usage">Pos. 90d</mat-option>
                        <mat-option value="name">Name</mat-option>
                        <mat-option value="konto">Konto</mat-option>
                    </mat-select>
                </mat-form-field>
                <span class="fc-count">{{ filteredArtikel.length }} Zeilen</span>
            </div>

            <table class="fc-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Bezeichnung</th>
                        <th>Kürzel</th>
                        <th>Buchungskonto</th>
                        <th>WG</th>
                        <th>Treffer</th>
                        <th>Tags</th>
                        <th>Lief.</th>
                        <th>Pos.</th>
                        <th>90d</th>
                        <th>Netto 90d</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let a of filteredArtikel" [class.row-issue]="!a.ok">
                        <td>{{ a.artikel_id }}</td>
                        <td class="col-name">{{ a.bezeichnung }}</td>
                        <td>{{ a.kuerzel }}</td>
                        <td class="mono">{{ a.buchungskonto || '—' }}</td>
                        <td class="col-wg">{{ a.warengruppe }}</td>
                        <td>{{ a.konten_treffer }}</td>
                        <td class="col-tags" [matTooltip]="a.tags || ''">
                            {{ a.tag_count }}
                            <span *ngIf="a.tags" class="tag-preview">{{ a.tags }}</span>
                        </td>
                        <td>{{ a.lieferant_links }}</td>
                        <td>{{ a.positionen_count }}</td>
                        <td>{{ a.positionen_90d }}</td>
                        <td class="num">{{ euro(a.netto_90d) }}</td>
                        <td>
                            <span *ngIf="a.ok" class="badge ok">OK</span>
                            <ng-container *ngIf="!a.ok">
                                <span class="badge warn" *ngFor="let iss of a.issues">{{ issueLabel(iss) }}</span>
                            </ng-container>
                        </td>
                    </tr>
                </tbody>
            </table>
        </section>

        <!-- LIEFERANTEN -->
        <section *ngIf="tab === 'lieferanten'">
            <p class="fc-hint">
                Aktive Lieferanten (90 Tage) – Kreditor kommt vom Lieferanten, nicht vom Artikel-Gegenkonto 1600.
            </p>
            <div class="fc-filters">
                <button mat-button type="button" [class.active]="liefFilter === 'all'" (click)="liefFilter = 'all'">Alle</button>
                <button mat-button type="button" [class.active]="liefFilter === 'issues'" (click)="liefFilter = 'issues'">
                    Probleme
                </button>
                <button mat-button type="button" [class.active]="liefFilter === 'ok'" (click)="liefFilter = 'ok'">OK</button>
                <mat-form-field class="fc-search" appearance="outline">
                    <mat-label>Suche</mat-label>
                    <input matInput [formControl]="liefSearchCtrl" placeholder="Name, Kreditor…" />
                </mat-form-field>
                <span class="fc-count">{{ filteredLieferanten.length }} Zeilen</span>
            </div>
            <table class="fc-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Lieferant</th>
                        <th>Kreditor</th>
                        <th>Gegenkonto</th>
                        <th>Artikel-Map</th>
                        <th>Belege 90d</th>
                        <th>Netto 90d</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let l of filteredLieferanten" [class.row-issue]="!l.ok">
                        <td>{{ l.lieferant_id }}</td>
                        <td>{{ l.lieferant }}</td>
                        <td class="mono">{{ l.kreditor_nr || '—' }}</td>
                        <td class="mono">{{ l.buchungsgegenkonto || '—' }}</td>
                        <td>{{ l.artikel_mappings }}</td>
                        <td>{{ l.belege_90d }}</td>
                        <td class="num">{{ euro(l.netto_90d) }}</td>
                        <td>
                            <span *ngIf="l.ok" class="badge ok">OK</span>
                            <span class="badge warn" *ngFor="let iss of l.issues">{{ issueLabel(iss) }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </section>

        <!-- ABWEICHUNGEN -->
        <section *ngIf="tab === 'abweichungen'" class="fc-table-wrap">
            <h2>Konto-Abweichungen gruppiert nach Artikel (180 Tage)</h2>
            <p class="fc-hint" *ngIf="!mismatchGroups.length">Keine Abweichungen im Zeitraum.</p>
            <div class="fc-group" *ngFor="let g of mismatchGroups">
                <button type="button" class="fc-group-head" (click)="toggleMismatch(mismatchKey(g))">
                    <mat-icon>{{ expandedMismatch === mismatchKey(g) ? 'expand_less' : 'expand_more' }}</mat-icon>
                    <strong>{{ g.artikel }}</strong>
                    <span class="mono">{{ g.artikelKonto }}</span>
                    <span class="fc-group-meta">{{ g.count }} Pos. · Σ {{ euro(g.nettoSum) }} €</span>
                </button>
                <table class="fc-table" *ngIf="expandedMismatch === mismatchKey(g)">
                    <thead>
                        <tr>
                            <th>Kosten-ID</th>
                            <th>Pos.</th>
                            <th>Lieferant</th>
                            <th>Pos. Sachkonto</th>
                            <th>Pos. Konto-Nr</th>
                            <th>Netto</th>
                            <th>Rechnung</th>
                            <th>Datum</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let m of g.rows">
                            <td>{{ m.kosten_id }}</td>
                            <td>{{ m.position }}</td>
                            <td>{{ m.lieferant || '—' }}</td>
                            <td class="mono">{{ m.position_sachkonto || '—' }}</td>
                            <td class="mono">{{ m.position_konto_nr || '—' }}</td>
                            <td class="num">{{ euro(m.kosten_netto) }}</td>
                            <td>{{ m.rechnung_nr }}</td>
                            <td>{{ m.datum | date: 'dd.MM.yyyy' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>

        <!-- NACH KONTO -->
        <section *ngIf="tab === 'konten'" class="fc-table-wrap">
            <h2>Artikel nach Sachkonto (Basis)</h2>
            <p class="fc-hint">Gruppiert nach Kontenbasis – zum Prüfen, ob Rahmen und Stamm zusammenpassen.</p>
            <div class="fc-group" *ngFor="let g of kontoGroups">
                <button type="button" class="fc-group-head" (click)="toggleKonto(g.baseKonto)">
                    <mat-icon>{{ expandedKonto === g.baseKonto ? 'expand_less' : 'expand_more' }}</mat-icon>
                    <strong class="mono">{{ g.baseKonto }}</strong>
                    <span class="fc-group-meta">
                        {{ g.artikelCount }} Artikel · {{ g.okCount }} OK ·
                        <span [class.warn-text]="g.issueCount > 0">{{ g.issueCount }} Probleme</span>
                        · {{ g.positionen90d }} Pos. · {{ euro(g.netto90d) }} €
                    </span>
                </button>
                <table class="fc-table" *ngIf="expandedKonto === g.baseKonto">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Bezeichnung</th>
                            <th>Konto</th>
                            <th>Tags</th>
                            <th>90d</th>
                            <th>Netto 90d</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let a of g.artikel" [class.row-issue]="!a.ok">
                            <td>{{ a.artikel_id }}</td>
                            <td>{{ a.bezeichnung }}</td>
                            <td class="mono">{{ a.buchungskonto || '—' }}</td>
                            <td>{{ a.tag_count }}</td>
                            <td>{{ a.positionen_90d }}</td>
                            <td class="num">{{ euro(a.netto_90d) }}</td>
                            <td>
                                <span *ngIf="a.ok" class="badge ok">OK</span>
                                <span class="badge warn" *ngFor="let iss of a.issues">{{ issueLabel(iss) }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>

        <!-- QUALITÄT -->
        <section *ngIf="tab === 'qualitaet'" class="fc-analyse">
            <h2>Positionsqualität (90 Tage)</h2>
            <div class="fc-kpi-row">
                <div class="fc-card" [class.warn]="(data.position_quality?.ohne_artikel || 0) > 0">
                    <span class="fc-num">{{ data.position_quality?.ohne_artikel || 0 }}</span>
                    <span class="fc-label">ohne Artikel</span>
                </div>
                <div class="fc-card" [class.warn]="(data.position_quality?.ohne_aufwand_konto || 0) > 0">
                    <span class="fc-num">{{ data.position_quality?.ohne_aufwand_konto || 0 }}</span>
                    <span class="fc-label">ohne Aufwandskonto</span>
                </div>
                <div class="fc-card">
                    <span class="fc-num">{{ data.position_quality?.freigegeben_90d || 0 }}</span>
                    <span class="fc-label">Belege freigegeben</span>
                </div>
                <div class="fc-card">
                    <span class="fc-num">{{ data.position_quality?.offen_90d || 0 }}</span>
                    <span class="fc-label">Belege offen</span>
                </div>
                <div class="fc-card">
                    <span class="fc-num">{{ data.duplicate_konten?.length || 0 }}</span>
                    <span class="fc-label">geteilte Konten</span>
                </div>
                <div class="fc-card">
                    <span class="fc-num">{{ data.unmatched_rahmen_konten?.length || 0 }}</span>
                    <span class="fc-label">Rahmen ohne Artikel</span>
                </div>
            </div>

            <div class="fc-grid-2 mt" *ngIf="data.ohne_aufwand_by_artikel?.length || data.ohne_aufwand_by_lieferant?.length">
                <div>
                    <h2>Ohne Aufwandskonto – nach Artikel</h2>
                    <p class="fc-hint">Technische Lücke (FK fehlt) – keine Kontenentscheidung für FiBu.</p>
                    <table class="fc-table">
                        <thead>
                            <tr>
                                <th>Artikel</th>
                                <th>Stamm</th>
                                <th>Pos.</th>
                                <th>Netto</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of data.ohne_aufwand_by_artikel">
                                <td>{{ r.artikel }}</td>
                                <td class="mono">{{ r.buchungskonto || '—' }}</td>
                                <td>{{ r.positionen }}</td>
                                <td class="num">{{ euro(r.netto) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <h2>Ohne Aufwandskonto – nach Lieferant</h2>
                    <table class="fc-table">
                        <thead>
                            <tr>
                                <th>Lieferant</th>
                                <th>Pos.</th>
                                <th>Netto</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of data.ohne_aufwand_by_lieferant">
                                <td>{{ r.lieferant }}</td>
                                <td>{{ r.positionen }}</td>
                                <td class="num">{{ euro(r.netto) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="fc-grid-2 mt">
                <div>
                    <h2>Mehrere Artikel pro Buchungskonto</h2>
                    <p class="fc-hint">Kann gewollt sein (z. B. Varianten) – bei hoher Nutzung prüfen.</p>
                    <div class="fc-group" *ngFor="let d of data.duplicate_konten">
                        <button type="button" class="fc-group-head" (click)="toggleDup(d.buchungskonto)">
                            <mat-icon>{{ expandedDup === d.buchungskonto ? 'expand_less' : 'expand_more' }}</mat-icon>
                            <strong class="mono">{{ d.buchungskonto }}</strong>
                            <span class="fc-group-meta">
                                {{ d.artikel_count }} Artikel · {{ d.positionen_90d }} Pos. · {{ euro(d.netto_90d) }} €
                            </span>
                        </button>
                        <table class="fc-table" *ngIf="expandedDup === d.buchungskonto">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Bezeichnung</th>
                                    <th>90d</th>
                                    <th>Netto</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let a of d.artikel">
                                    <td>{{ a.artikel_id }}</td>
                                    <td>{{ a.bezeichnung }}</td>
                                    <td>{{ a.positionen_90d }}</td>
                                    <td class="num">{{ euro(a.netto_90d) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div>
                    <h2>Häufigste Tags</h2>
                    <table class="fc-table">
                        <thead>
                            <tr>
                                <th>Tag</th>
                                <th>Artikel</th>
                                <th>Ø Gewicht</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let t of data.top_tags">
                                <td>{{ t.tag }}</td>
                                <td>{{ t.artikel_count }}</td>
                                <td>{{ t.avg_gewicht }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="fc-hint" *ngIf="!data.top_tags?.length">Keine Tags vorhanden.</p>
                </div>
            </div>

            <h2 class="mt">Aufwandskonten (4xxx) ohne Nebenkosten-Artikel</h2>
            <p class="fc-hint">
                Nur Sachaufwand 4xxx – Bank/USt/Kreditor ausgeblendet. Informativ, keine Pflichtaktion.
            </p>
            <table class="fc-table">
                <thead>
                    <tr>
                        <th>Konto-Nr</th>
                        <th>Bezeichnung</th>
                        <th>Sachkonto</th>
                        <th>Suffix</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let k of data.unmatched_rahmen_konten">
                        <td class="mono">{{ k.konto_nr }}</td>
                        <td>{{ k.bezeichnung }}</td>
                        <td class="mono">{{ k.sachkonto || '—' }}</td>
                        <td class="mono">{{ k.kostenstelle_suffix || '—' }}</td>
                    </tr>
                </tbody>
            </table>
        </section>
    </ng-container>
</div>
